import * as React from 'react'
import Head from 'next/head'

import { i18n } from '@thg-commerce/enterprise-core'

import { Container, HideParcelLabElements } from './styles'

declare global {
  interface Window {
    parcelLabTrackAndTrace?: {
      initialize: (options: any) => void
      track: (options: any) => void
      parcelLabUserId
    }
  }
}

interface ParcelLabWidgetProps {
  orderNumber: string
  email: string
  zipCode: string
  language?: string
  parcelLabUserId?: number
  showZipCodeInput?: string
}

export const ParcelLabWidget: React.FC<ParcelLabWidgetProps> = ({
  orderNumber,
  email,
  zipCode,
  language = 'en',
  parcelLabUserId,
  showZipCodeInput,
}) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [isInitialized, setIsInitialized] = React.useState(false)

  const i18nText = {
    loadingMessage: i18n('widget.parcellab.content.loading.text'),
  }

  React.useEffect(() => {
    if (orderNumber && zipCode && !isInitialized) {
      const script = document.createElement('script')
      script.src = 'https://cdn.parcellab.com/js/v5/main.min.js'
      script.async = true

      script.onload = () => {
        if (window.parcelLabTrackAndTrace) {
          window.parcelLabTrackAndTrace.initialize({
            lang: language,
            userId: parcelLabUserId?.toString(),
            show_searchForm: false,
            show_zipCodeInput: showZipCodeInput,
            containerId: 'parcellab-container',
          })

          window.parcelLabTrackAndTrace?.track({
            zipCode,
            email: email || undefined,
            orderId: orderNumber,
          })

          setIsInitialized(true)
          setIsLoading(false)
        }
      }

      script.onerror = () => {
        console.error('Failed to load ParcelLab script')
        setIsLoading(false)
      }

      document.head.appendChild(script)
      setIsLoading(true)

      return () => {
        if (document.head.contains(script)) {
          document.head.removeChild(script)
        }
      }
    }
  }, [orderNumber, zipCode, email, language, isInitialized, parcelLabUserId])

  return (
    <React.Fragment>
      <Head>
        <link
          rel="stylesheet"
          href="https://cdn.parcellab.com/css/v5/main.min.css"
          key="parcellab-styles"
        />
      </Head>
      <div>
        <HideParcelLabElements />
        <Container id="parcellab-container">
          {isLoading && <div>{i18nText.loadingMessage}</div>}
        </Container>
      </div>
    </React.Fragment>
  )
}
